import axios from 'axios'
import { ARTICULOS } from '../conexiones';
import { allArticulos, articuloId, articuloNew } from './articulosSlice';

export const getAllArticulos = () => {
    return async (dispatch) => {
        try {
            await axios.get(ARTICULOS)
            .then(res => dispatch(allArticulos(res.data)))            
        } catch (error) {
            console.log(error);            
        }        
    }
}

export const getArticuloId = (id) => {
    return async (dispatch) => {
        try {
            await axios.get(`${ARTICULOS}/${id}`)
            .then(res => dispatch(articuloId(res.data)))            
        } catch (error) {
            console.log(error);            
        }        
    }
}

export const postArticulo = (payload) => {
    return async (dispatch) => {
        try {
            await axios.post(ARTICULOS, payload)
            .then(res => dispatch(articuloNew(res.data)))
        } catch (error) {
            console.log(error);            
        }
    }
}